import OreCanvas from "../components/draw/OreCanvas";

export function getBase64(canvas) {
  return canvas.toDataURL("image/png");
}

let captureCanvas = null;

export function convertBase64(img, width, height) {
  if (!captureCanvas) {
    captureCanvas = new OreCanvas(img.width, img.height);
  }
  captureCanvas.clear();

  width = width || img.width;
  height = height || img.height;
  captureCanvas.setSize(width, height);
  captureCanvas.captureImage(img, width, height);
  console.log("img.width, img.height", img.width, img.height);
  console.log(
    "captureCanvas.canvas.width, captureCanvas.canvas.height",
    captureCanvas.canvas.width,
    captureCanvas.canvas.height
  );
  console.log("width, height", width, height);
  return captureCanvas.getBase64();
}

export function drawImage(context, img, x, y, crop, imgRatio = 1) {
  let dx = 0;
  let dy = 0;
  let dw = crop;
  let dh = crop;
  if (x < 0) {
    dx = -x;
    x = 0;
    dw = crop + x;
  }
  if (y < 0) {
    dy = -y;
    y = 0;
    dh = crop + y;
  }

  // 画像範囲外を許容しない厳格な処理（全ブラウザ統一）
  const scaleX = (img.naturalWidth || img.width) / (img.width || 1);

  const sx = Math.round((x / imgRatio) * scaleX);
  const sy = Math.round((y / imgRatio) * scaleX);
  let sw = Math.round((crop / imgRatio) * scaleX);
  let sh = Math.round((crop / imgRatio) * scaleX);

  const ddx = Math.round(dx);
  const ddy = Math.round(dy);
  let ddw = Math.round(dw);
  let ddh = Math.round(dh);

  // 画像範囲を超えないように調整（全ブラウザで適用）
  // 切り取りサイズと描画サイズの比率を維持
  if (sx + sw > img.width) {
    const actualSw = img.width - sx;
    ddw = Math.round(dw * (actualSw / sw));
    sw = actualSw;
  }
  if (sy + sh > img.height) {
    const actualSh = img.height - sy;
    ddh = Math.round(dh * (actualSh / sh));
    sh = actualSh;
  }

  context.drawImage(img, sx, sy, sw, sh, ddx, ddy, ddw, ddh);
}
